import { createElementObject, createPathComponent, extendContext } from '@react-leaflet/core';
export const LeafletPolygon = createPathComponent(function createPolygon({ positions , ...options }, ctx) {
    const polygon = new window.L.polygon(positions, options);
    return createElementObject(polygon, extendContext(ctx, {
        overlayContainer: polygon
    }));
}, function updatePolygon(layer, props, prevProps) {
    if (props.positions !== prevProps.positions) {
        layer.setLatLngs(props.positions);
    }
});
